import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";

const EditDocumentModal = ({ show, onHide, document, onSave }) => {
  const [formData, setFormData] = useState(document || {});

  useEffect(() => {
    if (document) {
      setFormData(document);
    }
  }, [document]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="documentName">
            <Form.Label>Document Name</Form.Label>
            <Form.Control
              type="text"
              name="documentName"
              value={formData.documentName || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group controlId="documentType">
            <Form.Label>Document Type</Form.Label>
            <Form.Control
              type="text"
              name="documentType"
              value={formData.documentType || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group controlId="documentNo">
            <Form.Label>Document No</Form.Label>
            <Form.Control
              type="text"
              name="documentNo"
              value={formData.documentNo || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group controlId="details">
            <Form.Label>Details</Form.Label>
            <Form.Control
              type="text"
              name="details"
              value={formData.details || ""}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDocumentModal;
